module.exports = __webpack_public_path__ + "img/banner_2_km.f355f22d.png";